<template>
  <div class="pagoda-card-list-item-wrapper">
    <el-card :style="cardItemStyle">
      <slot></slot>
    </el-card>
  </div>
</template>

<script>
  import {
    isNumber
  } from '../../../utils'

  export default {
    name: 'CardListItem',
    inject: ['cardListInstance'],
    computed: {
      cardItemStyle () {
        const {
          itemWidth,
          itemHeight
        } = this.cardListInstance

        return {
          width: isNumber(itemWidth) ? `${itemWidth}px` : itemWidth,
          height: isNumber(itemHeight) ? `${itemHeight}px` : itemHeight
        }
      }
    }
  }
</script>
